import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import * as actions from '../redux/actions';
import CollectionDetail from '../collections/CollectionDetail';
import { getBuilderConfigURL } from '../../../common/utils/builder-config-url-util';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { findBySearchString } from '../../../common/utils/jsonUtils';
import CustomLoader from '../../common/CustomLoader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
export class CollectionTab extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    editor: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = {
    searchQuery: '',
    collectionsBySearch: [],
    showLoader: false,
    expandedSections: ['SYSTEM'],
  };

  componentDidMount() {
    const { projectId, actions, version } = this.props;
    actions.loadCollections({ projectId, version });
  }

  handleRefresh() {
    this.setState({ showLoader: true });
    const { projectId, actions, version } = this.props;
    actions
      .loadCollections({ projectId, version })
      .then(() => this.setState({ showLoader: false }));
  }

  filterCollectionBySearch = (event) => {
    const { value } = event.target;
    const { editor } = this.props;
    const { collections = [] } = editor;
    const filteredCollections = value
      ? findBySearchString('collectionTitle', value, collections)
      : collections;
    const expandedSections = [];
    if (filteredCollections.some((collection) => collection.isPluginCollection))
      expandedSections.push('SYSTEM');
    if (filteredCollections.some((collection) => !collection.isPluginCollection))
      expandedSections.push('GENERAL');

    this.setState({ searchQuery: value, expandedSections });
  };

  listOfCollectionsToShow = (collections) => {
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    let redirectUrl = getBuilderConfigURL();
    return collections
      .sort((a, b) => {
        return a.collectionIndex > b.collectionIndex
          ? 1
          : a.collectionIndex == b.collectionIndex
          ? 0
          : -1;
      })
      .map((collection) => (
        <CollectionDetail
          key={collection.uuid}
          collection={collection}
          openCollectionSetting={this.openCollectionSetting}
          openItemList={this.openItemList}
          projectId={this.props.projectId}
          version={this.props.version}
          redirectUrl={redirectUrl}
        />
      ));
  };

  showCollectionDetail = (collections) => {
    const { searchQuery } = this.state;
    const filteredCollections = searchQuery
      ? findBySearchString('collectionTitle', searchQuery, collections)
      : collections;
    return filteredCollections.length > 0 ? (
      this.listOfCollectionsToShow(filteredCollections)
    ) : (
      <p style={{ fontSize: '14px', margin: '0 0 10px' }}>No matching your search.</p>
    );
  };
  renderAccordionContent = (collections) => {
    return (
      <>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-devices-c"></div>
          {this.showCollectionDetail(collections)}
        </div>
      </>
    );
  };

  renderAccordion = (collections) => {
    const accordionSections = [
      {
        Id: 'SYSTEM',
        title: 'System',
        collections: collections.filter((collection) => collection.isPluginCollection),
      },
      {
        Id: 'GENERAL',
        title: 'General',
        collections: collections.filter((collection) => !collection.isPluginCollection),
      },
    ];
    return accordionSections.map(({ Id, title, collections }) => (
      <AccordionItem key={Id} uuid={Id}>
        <AccordionItemState>
          {({ expanded }) => (
            <>
              <AccordionItemHeading className="gjs-block-category">
                <AccordionItemButton className="gjs-title">
                  <span
                    className={
                      expanded
                        ? 'gjs-caret-icon fa fa-caret-down'
                        : 'gjs-caret-icon fa fa-caret-right'
                    }
                  ></span>
                  &nbsp;
                  {title}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                {collections.length === 0 ? (
                  <div>No collection available</div>
                ) : (
                  this.renderAccordionContent(collections)
                )}
              </AccordionItemPanel>
            </>
          )}
        </AccordionItemState>
      </AccordionItem>
    ));
  };
  render() {
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    let redirectUrl = getBuilderConfigURL();
    const { projectId, version, editor } = this.props;
    const { collections = [] } = editor;
    const { showLoader, searchQuery, expandedSections } = this.state;
    const totalCollectionCount = collections.length;
    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Collections" className="padding-left-20">
              Collections&nbsp;
              <span
                style={{ fontSize: '12px', cursor: 'help' }}
                data-tip="Total"
                title={'Total: ' + totalCollectionCount}
              >
                <i className="webconnect webconnect-info-circle"></i>
              </span>
            </span>
            <span
              title="Reload Collections"
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-cancel btn-xs"
                data-tip="Reload Collections"
                data-place="bottom"
                data-effect="solid"
                onClick={() => this.handleRefresh()}
              >
                <i className="wb webconnect-refresh"></i>
              </a>
            </span>
            <span title="Add Collection" className="">
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip="Create New Collection"
                data-place="bottom"
                data-effect="solid"
                onClick={() => {
                  Mixpanel.track('Clicked on- Add Collection button on builder');
                }}
                href={`${redirectUrl}collections/${version}/v/${projectId}/create?token=${token}`}
              >
                <i className="wb webconnect-plus"></i>&nbsp;Add Collection
              </a>
            </span>
          </div>
          <div className="gjs-devices-c"></div>
        </div>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-devices-c"></div>
          <div className="form-outline" style={{ padding: '10px' }}>
            <input
              type="search"
              className="form-control form-control-sm"
              placeholder="&#xf55c; Eg: User"
              style={{ fontFamily: 'Arial, Webconnect' }}
              value={searchQuery}
              onChange={this.filterCollectionBySearch}
            />
          </div>
          {showLoader ? (
            <CustomLoader loading={showLoader} />
          ) : (
            <Accordion
              key={expandedSections.join(',')}
              allowZeroExpanded
              preExpanded={expandedSections}
            >
              {this.renderAccordion(collections)}
            </Accordion>
          )}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionTab);
